<form [formGroup]="editSourceForm" (ngSubmit)="onSubmit()" onsipFormTracking>
  <div mat-dialog-content class="add-music-source-dilog-content">
    <div class="form-content">
      <h2 class="modal-header">
        {{
          (this.data ? "ONSIP_I18N.EDIT_MUSIC_SOURCE" : "ONSIP_I18N.ADD_MUSIC_SOURCE") | translate
        }}
      </h2>
      <div class="control-wrapper">
        <div class="mat-body-1">{{ "ONSIP_I18N.NAME" | translate }}</div>
        <mat-form-field appearance="outline">
          <input
            matInput
            required
            placeholder="{{ 'ONSIP_I18N.NAME' | translate }}"
            autocomplete="off"
            formControlName="name"
          />
          @if (editSourceForm.get('name')?.hasError('required')) {
          <mat-error>
            {{ "ONSIP_I18N.NAME_IS_REQUIRED" | translate }}
          </mat-error>
          } @if ( !editSourceForm.get('name')?.hasError('required') &&
          editSourceForm.get('name')?.hasError(BACKEND_ERROR) ) {
          <mat-error>
            {{ editSourceForm.get("name")?.getError(BACKEND_ERROR) }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="control-wrapper">
        <div class="mat-body-1">{{ "ONSIP_I18N.SOURCE_URL" | translate }}</div>
        <mat-form-field appearance="outline">
          <input
            matInput
            required
            placeholder="{{ 'ONSIP_I18N.SOURCE' | translate }}"
            autocomplete="off"
            formControlName="url"
          />
          @if (editSourceForm.get('url')?.hasError('required')) {
          <mat-error>
            {{ "ONSIP_I18N.SOURCE_IS_REQUIRED" | translate }}
          </mat-error>
          } @if ( !editSourceForm.get('url')?.hasError('required') &&
          editSourceForm.get('url')?.hasError(BACKEND_ERROR) ) {
          <mat-error>
            {{ editSourceForm.get("url")?.getError(BACKEND_ERROR) }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="sources">
        @if ((isSourcesListLoading | async) === false) {
        <mat-form-field appearance="outline" class="search-control">
          <mat-label>{{ "ONSIP_I18N.SEARCH" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'ONSIP_I18N.SEARCH' | translate }}"
            autocomplete="off"
            [formControl]="searchControl"
          />
          <mat-icon matSuffix class="search-icon">search</mat-icon>
        </mat-form-field>
        @if (displayedSources | async; as templateDisplaySources) { @if
        (!!templateDisplaySources.length) {
        <cdk-virtual-scroll-viewport [itemSize]="27" class="scrolling-container">
          <div *cdkVirtualFor="let sourcesWithGenre of templateDisplaySources; trackBy: trackByFn">
            @if (!!sourcesWithGenre.sources) {
            <div class="mat-body-1 genre">
              {{ sourcesWithGenre.genre }}
            </div>
            } @if (!sourcesWithGenre.sources) {
            <mat-checkbox
              color="primary"
              class="music-source"
              [checked]="sourcesWithGenre.isChecked"
              (change)="setCurrentMusicSource(sourcesWithGenre)"
            >
              {{ sourcesWithGenre.name }}
            </mat-checkbox>
            }
          </div>
        </cdk-virtual-scroll-viewport>
        } @else {
        <div>
          {{ "ONSIP_I18N.NO_RESULTS" | translate }}
        </div>
        } } } @else {
        <div class="sources-loader scrolling-container">
          <mat-spinner></mat-spinner>
        </div>
        }
      </div>
    </div>
    @if (!isCustomSourceLink) {
    <div class="audio-container">
      <audio
        [attr.src]="audioSourceUrl | async"
        (loadedmetadata)="changeAudioSourceCheckState(audioSourceCheckStates.VALID)"
        (error)="changeAudioSourceCheckState(audioSourceCheckStates.INVALID)"
        controls
        controlsList="nodownload"
        class="audio"
      ></audio>
    </div>
    }
    <p class="audio-check-status">
      @if ( editSourceForm.get('audioSourceCheckState')?.invalid && editSourceForm.get('url')?.value
      ) { @if ( editSourceForm.get('audioSourceCheckState')?.value ===
      audioSourceCheckStates.CHECKING ) {
      <span class="checking-audio">Checking music source</span>
      <span><mat-spinner diameter="16"></mat-spinner></span>
      } @if ( editSourceForm.get('audioSourceCheckState')?.value === audioSourceCheckStates.INVALID
      ) {
      <span class="invalid-audio">Source is invalid. Please check the URL.</span>
      } }
    </p>
  </div>
  <div mat-dialog-actions class="footer modal-actions">
    <button mat-button type="button" class="cancel" color="primary" (click)="closeDialog()">
      {{ "ONSIP_I18N.CANCEL" | translate }}
    </button>
    <button
      mat-flat-button
      type="submit"
      color="primary"
      [disabled]="(isSavingMusicSource | async) || editSourceForm.invalid"
      [onsipFormSubmit]="editSourceForm"
    >
      {{ (this.data ? "ONSIP_I18N.SAVE" : "ONSIP_I18N.ADD") | translate }}
    </button>
  </div>
</form>
